import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import DATE from '@amf/shared/utils/date';
import Tippy from '@tippyjs/react';
import { useTranslate } from '@tolgee/react';
import { isWMF } from '@amf/shared/utils/wmf';

type Props = {
  date: Date;
  format: string;
  type?: 'main' | 'browser';
  className?: string;
  disableTooltip?: boolean;
};

function FormattedDate({
  date,
  format,
  type = 'main',
  disableTooltip: disableTooltipFromProps,
  className,
}: Props) {
  const { t } = useTranslate();
  const { locale } = useRouter();
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!isReady) return null;

  const { main, browser } = DATE.format(date, format, locale);
  const disableTooltip = isWMF()
    ? disableTooltipFromProps ?? DATE.isBrowserHasSameTimeZoneOffset()
    : true;

  if (type !== 'browser' && !disableTooltip) {
    return (
      <Tippy
        content={
          <>
            {browser} {t('date.local-time')}
          </>
        }
        animation='shift-away'
        placement='bottom'
        theme='light'
      >
        <time className={className}>{main}</time>
      </Tippy>
    );
  }

  return <time className={className}>{type === 'browser' ? browser : main}</time>;
}

export default FormattedDate;
